export default "__VITE_ASSET__26ad07be__"